<aside-menu>
    <route path="(.*)">
        <div if={route.hash !== '#login'} class="sidebar-content">
            <div class="teacher-profile">
                <div class="teacher-avatar" aria-hidden="true">{initials(props.teacher && props.teacher.name)}</div>
                <div class="teacher-details">
                    <strong>{props.teacher ? props.teacher.name : 'Memuat profil...'}</strong>
                    <small if={props.teacher && props.teacher.alternativeId} class="text-gray">NIP: {props.teacher.alternativeId}</small>
                    <small if={props.teacher && props.teacher.school} class="text-gray">{props.teacher.school.name}</small>
                    <small if={props.teacher && props.teacher.role} class="text-gray">{roleLabel(props.teacher.role)}</small>
                </div>
            </div>

            <button class="btn mobile-menu-button" type="button" aria-controls="school-navigation" aria-expanded={state.menuOpen ? 'true' : 'false'} onclick={toggleMenu}>
                <i class="icon icon-menu"></i>
                <span>{state.menuOpen ? 'Tutup menu' : 'Buka menu'}</span>
            </button>

            <div id="school-navigation" onkeydown={onMenuKeydown} class="menu-panel {state.menuOpen ? 'is-open' : ''}">
            <ul class="nav">
                <li each={item in visibleItems()} class="nav-item {isLinkSelected(item, route) ? 'active' : ''}">
                    <a href="{item.link}" onclick={closeMenu}>{item.label}</a>
                    <template if={item.children}>
                        <ul class="nav">
                            <li each={child in item.children} class="nav-item">
                                <a href="{child.link}" onclick={closeMenu}>{child.label}</a>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>

            <div if={state.logoutError} class="toast toast-error logout-error">{state.logoutError}</div>
            <button class="btn btn-link logout-button loading-{state.loggingOut}"
                    disabled={state.loggingOut}
                    onclick={logout}>Keluar</button>
            </div>
        </div>
    </route>

    <style>
        aside-menu .sidebar-content { min-width: 0; }
        aside-menu .teacher-profile {
            align-items: center;
            border-bottom: .05rem solid #dadee4;
            display: flex;
            gap: .6rem;
            margin-bottom: .8rem;
            padding: .25rem .2rem .9rem;
        }
        aside-menu .teacher-avatar {
            align-items: center;
            background: #5755d9;
            border-radius: 50%;
            color: #fff;
            display: flex;
            flex: 0 0 2.2rem;
            font-size: .8rem;
            font-weight: 600;
            height: 2.2rem;
            justify-content: center;
            letter-spacing: .02em;
        }
        aside-menu .teacher-details { min-width: 0; }
        aside-menu .teacher-details strong,
        aside-menu .teacher-details small {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        aside-menu .teacher-details strong { font-size: .75rem; }
        aside-menu .teacher-details small { font-size: .6rem; margin-top: .1rem; }
        aside-menu .logout-button { margin-top: 1rem; text-align: left; width: 100%; }
        aside-menu .logout-error { font-size: .6rem; margin-top: .8rem; }
        aside-menu .mobile-menu-button { display: none; }

        @media (max-width: 840px) {
            aside-menu .teacher-profile { border-bottom: 0; margin: 0; padding: 0; }
            aside-menu .sidebar-content { position: relative; }
            aside-menu .mobile-menu-button {
                align-items: center;
                display: inline-flex;
                gap: .4rem;
                margin-top: .75rem;
                width: 100%;
            }
            aside-menu .menu-panel { display: none; }
            aside-menu .menu-panel.is-open {
                background: #fff;
                border: .05rem solid #dadee4;
                border-radius: .25rem;
                box-shadow: 0 .2rem .8rem rgba(48, 55, 66, .12);
                display: block;
                padding: .5rem .75rem .75rem;
                margin-top: .35rem;
                z-index: 20;
            }
            aside-menu .nav a { min-height: 2.2rem; padding: .5rem .4rem; }
        }
    </style>

    <script>
        import {router} from '@riotjs/route'

        export default {
            state: {
                menuOpen: false,
                loggingOut: false,
                logoutError: '',
                items: [
                    {
                        "label": "Home",
                        "link": "#",
                        "roles": ["school_admin", "teacher"],
                    },
                    {
                        "label": "Data Awal",
                        "link": "#setup",
                        "roles": ["school_admin", "teacher", "platform_admin"],
                    },
                    {
                        "label": "Pengguna & Akses",
                        "link": "#administration",
                        "roles": ["school_admin"],
                    },
                    {
                        "label": "Siswa",
                        "link": "#students",
                        "roles": ["school_admin", "teacher"],
                    },
                    {
                        "label": "Absensi",
                        "link": "#absensi",
                        "roles": ["school_admin", "teacher"],
                        "children": [
                            {
                                "label": "Input",
                                "link": "#absensi/input"
                            },
                            {
                                "label": "Rekap",
                                "link": "#absensi/stats",
                            },
                            {
                                "label": "Rekap Klasikal",
                                "link": "/#absensi/stats-classical",
                            }
                        ]
                    },
                    {
                        "label": "About",
                        "link": "#about",
                        "roles": ["school_admin", "teacher", "platform_admin"],
                    },
                    {
                        "label": "Sekolah",
                        "link": "#platform/schools",
                        "roles": ["platform_admin"],
                    }
                ]
            },
            toggleMenu(event) {
                event.preventDefault()
                this.update({menuOpen: !this.state.menuOpen})
            },
            onMenuKeydown(event) {
                if (event.key === 'Escape') {
                    this.closeMenu()
                    this.root.querySelector('.mobile-menu-button').focus()
                }
            },
            closeMenu() {
                this.update({menuOpen: false})
            },
            isLinkSelected(item, route) {
                const isHome = !route.hash || route.hash === '#'
                if (item.link === '#') {
                    return isHome
                }
                return !isHome && route.hash.includes(item.link)
            },
            initials(name) {
                const words = String(name || '').trim().split(/\s+/).filter(Boolean)
                if (!words.length) return '--'
                if (words.length === 1) return Array.from(words[0]).slice(0, 2).join('').toUpperCase()
                return `${Array.from(words[0])[0]}${Array.from(words[words.length - 1])[0]}`.toUpperCase()
            },
            visibleItems() {
                const role = this.props.teacher && this.props.teacher.role
                return this.state.items.filter(item => !item.roles || item.roles.includes(role))
            },
            roleLabel(role) {
                return ({platform_admin: 'Administrator Platform', school_admin: 'Administrator Sekolah', teacher: 'Guru'})[role] || role
            },
            logout(event) {
                event.preventDefault()
                if (this.state.loggingOut) return
                this.update({loggingOut: true, logoutError: ''})
                axios.post('/api/v1/teacher/logout')
                    .then(() => router.push('/#login'))
                    .catch(error => this.update({
                        logoutError: error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'Tidak dapat keluar. Silakan coba lagi.',
                    }))
                    .finally(() => this.update({loggingOut: false}))
            }
        }
    </script>
</aside-menu>
